export default __webpack_public_path__ + "static/larar-fortbildning-logo-83b4172164b6e735a7d115c3394a1c9c.svg";